import React, { useCallback, useEffect, useRef, useState } from "react";
import BackButton from "../../generic/elements/backbutton/BackButton";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";
import SearchInput from "../../generic/elements/search/SearchInput";
import { Row, Spin } from "antd";
import CreateOrganizationModal from "./CreateOrganizationModal";
import OrganizationTable from "./OrganizationTable";
import { useRecoilState } from "recoil";
import { organizationDataState } from "../../../components/recoil/organizationDataRecoil";
import OrganizationTableActions from "./OrganizationTableActions";
import apiService from "../../../service/apiservice/apiService";

const Organizations = () => {
  const organizationRef = useRef();
  const [openOrganizationModal, setOpenOrganizationModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [action, setAction] = useState("");
  const [tableLoading, setTableLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [organizationList, setOrganizationListData] = useRecoilState(
    organizationDataState
  );

  const openModal = useCallback(() => {
    setOpenOrganizationModal(true);
  }, []);

  const handleCreateClick = useCallback(() => {
    setAction("Create");
    openModal();
  }, [openModal]);

  const handleEditClick = useCallback(
    (id) => {
      setAction("Update");
      const organization = organizationList.find((item) => item?.id === id);
      organizationRef.current?.setOrganizationData({
        ...organization,
        completeAddress: organization?.address,
      });
      organizationRef.current?.setOrganizationIdentifier(organization?.id);
      openModal();
    },
    [openModal, organizationList, setAction]
  );

  const columns = [
    {
      title: "Id",
      key: "id",
      dataIndex: "id",
    },
    {
      title: "Name",
      key: "name",
      dataIndex: "name",
    },
    {
      title: "Action",
      key: "action",
      render: (_, organization) => (
        <OrganizationTableActions
          organization={organization}
          handleEditClick={handleEditClick}
        />
      ),
    },
  ];

  const renderCreateOrganizationModal = (
    <CreateOrganizationModal
      openOrganizationModal={openOrganizationModal}
      setOpenOrganizationModal={setOpenOrganizationModal}
      ref={organizationRef}
      action={action}
      setRefresh={setRefresh}
    />
  );

  useEffect(() => {
    const fetchOrganizations = async () => {
      setTableLoading(true);
      const endpoint = "niramayafoundation/api/v1/organization";
      const params = {
        searchQuery,
      };

      const response = await apiService.get(endpoint, params);
      setOrganizationListData(response);
      setTableLoading(false);
    };

    fetchOrganizations();
  }, [refresh, searchQuery, setOrganizationListData]);

  return (
    <>
      <section className="section-content">
        <div className="fixed-content">
          <div className="form-renderer-back-button">
            <BackButton />
            <p>Organizations</p>
          </div>
          <div className="patient-list-search-section">
            <Row className="search-container">
              <SearchInput
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                cssClass="searchFilterContainer"
                searchPlaceholder="Search organization..."
              />
              <PrimaryButton
                buttonText="Create Organization"
                handleOnClick={handleCreateClick}
              />
            </Row>
          </div>
        </div>

        {tableLoading ? (
          <Spin size="large" className="spinnerCenter" />
        ) : (
          <OrganizationTable columns={columns} tableData={organizationList} />
        )}
      </section>

      {renderCreateOrganizationModal}
    </>
  );
};

export default Organizations;
